import { render, staticRenderFns } from "./SyncDashboardCard.vue?vue&type=template&id=63f952ad&scoped=true"
import script from "./SyncDashboardCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SyncDashboardCard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SyncDashboardCard.vue?vue&type=style&index=0&id=63f952ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f952ad",
  null
  
)

export default component.exports